import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'seikural_visitor_count_v2';
const DEFAULT_VISITOR_COUNT = 0;

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(DEFAULT_VISITOR_COUNT);

  useEffect(() => {
    try {
      const savedValue = window.localStorage.getItem(STORAGE_KEY);
      if (savedValue === null) {
        window.localStorage.setItem(STORAGE_KEY, String(DEFAULT_VISITOR_COUNT));
        return;
      }

      const savedCount = Number(savedValue);
      const safeCount = Number.isSafeInteger(savedCount) && savedCount >= 0
        ? savedCount
        : DEFAULT_VISITOR_COUNT;
      const nextCount = safeCount + 1;
      window.localStorage.setItem(STORAGE_KEY, String(nextCount));
      setVisitorCount(nextCount);
    } catch (error) {
      console.error('Unable to update visitor count:', error);
      setVisitorCount(DEFAULT_VISITOR_COUNT);
    }
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center text-center" aria-live="polite">
      <span className="tw-text-slate-300 me-2" style={{ fontSize: '0.8rem' }}>
        Visitors:
      </span>
      <span className="fw-semibold tw-text-teal-400" style={{ fontSize: '0.8rem' }}>
        {visitorCount.toLocaleString()}
      </span>
    </div>
  );
};

export default VisitorCounter;
